import { createRootRouteWithContext } from '@tanstack/react-router';
import type { RouterContext } from '@/router';

export const Route = createRootRouteWithContext<RouterContext>()();
